import { render, staticRenderFns } from "./RelatorioLogAnoLetivo.vue?vue&type=template&id=45d7bad9"
import script from "./RelatorioLogAnoLetivo.vue?vue&type=script&lang=js"
export * from "./RelatorioLogAnoLetivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports